import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface DetailsSectionProps {
  label: string;
  children: React.ReactNode;
  containerStyle?: ViewStyle;
  labelStyle?: TextStyle;
}

export const DetailsSection: React.FC<DetailsSectionProps> = ({ label, children, containerStyle, labelStyle }) => {
  return (
    <View style={[styles.section, containerStyle]}
    >
      <Text style={[styles.sectionLabel, labelStyle]}>{label}</Text>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  sectionLabel: {
    color: ADMIN_COLORS.TEXT_SECONDARY,
    fontSize: 12,
    marginBottom: 6,
  },
});


